/* =========================================================
   Life InStyle — scroll reveal.

   Sections fade and rise as they enter view. Ported from the pitch demo
   (js/main.js), where it ran across the whole site.

   OPT-IN, NOT BLANKET — and that is a correctness decision, not caution.
   The reveal animates `transform`, and a transformed element becomes the
   containing block for everything inside it, which silently breaks
   `position: sticky` descendants. Dawn uses sticky in at least two places we
   care about: the horizontal filter bar (component-facets.css) and the product
   media column (section-main-product.css). Revealing those sections would leave
   both looking subtly broken with nothing in the console to explain it.

   So this only touches elements carrying `.instyle-section` — the class our own
   sections already declare in their schema. Dawn's sections never have it, and
   neither does the hero, whose sticky scroll-scrub would break the same way.

   To opt a new section in: add `"class": "instyle-section"` to its schema.
   ========================================================= */
(function () {
  var SELECTOR = '.instyle-section';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('instyle-reveal--in');
        // One-shot. Re-animating on every pass reads as a glitch, not polish.
        io.unobserve(e.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function wire(el) {
    if (el.dataset.instyleReveal) return;
    el.dataset.instyleReveal = '1';

    // Already on screen at load — show it immediately rather than animating
    // something the visitor is looking at.
    var box = el.getBoundingClientRect();
    if (box.top < window.innerHeight * 0.9) {
      el.classList.add('instyle-reveal', 'instyle-reveal--in');
      return;
    }

    el.classList.add('instyle-reveal');
    io.observe(el);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // The theme editor swaps sections in and out without a reload.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
